import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useFollowCourse } = getCRUDHooks({
  entityName: 'followCourse',
  sharedCacheEntities: ['followedCoursesList'],
  create: ({ courseId, userId }: { courseId: number; userId: number }) =>
    clientApi.getOCClient().helpers.learningActivity.courses.follow(userId, courseId),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useFollowCourse,
};
